const PlanningToolsIcon = () => {
  return (
    <svg
      style={{
        width: "2rem",
        height: "2rem",
      }}
      focusable="false"
      class="pub__svg-icon c21nsg2"
      aria-hidden="true"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.3313 4.582 12 11.0002v4.0015h3.9912l6.4281-6.3234-4.088-4.0963zM14 11.8207l4.3396-4.3991 1.2411 1.2436-4.4083 4.3365H14v-1.181z"
      ></path>
      <path d="M4 5.0018h10v2H6v8H4v-10zm18 14H2v-2h20v2z"></path>
    </svg>
  );
};
export default PlanningToolsIcon;
